import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const myPayHistoryApi = createApi({
  reducerPath: 'myPayHistoryApi',
  baseQuery: fetchBaseQuery({ baseUrl: '/api' }),
  endpoints: builder => ({
    updatePayHistoryAddress: builder.mutation<
      any,
      {
        muid: string;
        saveDefaultAddress: boolean;
        address1: string;
        address2: string;
        city: string;
        stateRegion: string;
        postalCode: string;
      }
    >({
      query: ({
        muid,
        saveDefaultAddress,
        address1,
        address2,
        city,
        stateRegion,
        postalCode,
      }) => ({
        url: `/users/payment-history/${muid}`,
        method: 'PUT',
        body: {
          address1,
          address2,
          city,
          stateRegion,
          postalCode,
          saveDefaultAddress,
        },
      }),
    }),
    updatePayHistoryName: builder.mutation<any, { muid: string; name: string }>(
      {
        query: ({ muid, name }) => ({
          url: `/users/payment-history/${muid}/name`,
          method: 'POST',
          body: {
            name,
          },
        }),
      },
    ),
    updatePayHistoryMobileNumber: builder.mutation<
      any,
      { muid: string; mobileNumber: string }
    >({
      query: ({ muid, mobileNumber }) => ({
        url: `/users/payment-history/${muid}/mobile-number`,
        method: 'POST',
        body: {
          mobileNumber,
        },
      }),
    }),
  }),
});

export const {
  useUpdatePayHistoryAddressMutation,
  useUpdatePayHistoryNameMutation,
  useUpdatePayHistoryMobileNumberMutation,
} = myPayHistoryApi;
